<template>
    <div class="llm-width">
        <a-row>
            <a-col span="20">
                <div class="messages" id="messages">
                    <p style="text-align: center">
                        <span class="message-time">{{formatTime(join_time || (new Date()/1000))}}</span>
                    </p>
                    <a-list
                            :dataSource="messages"
                            :split="false"
                    >
                        <template #renderItem="{item}">
                            <a-list-item :class="`message-item ${item.role}`" :id="item.ele_id">
                                <a-list-item-meta >

                                    <template #title>
                                        <p style="text-align: center" v-if="item.time">
                                            <span class="message-time">{{formatTime(item.time)}}</span>
                                        </p>
                                        <a-space v-if="item.role !== 'user' && item.stage !=='detail' && item.stage !=='completed'">
                                            <a-avatar :src="require('@/assets/Machine Learning.svg')" :class="`avatar-${item.role}`"/>
                                            <p :class="`author-${item.role}`">{{ item.author }}</p>
                                        </a-space>
                                    </template>
                                    <template #description>
                                        <div style="margin-left: 40px;color:#000000">
                                            <div v-if="item.role==='user'">
                                                <div>
                                                    <a-space style="float: right">
                                                        <p style="color: rgba(0,0,0,0.88);font-weight:500">{{ item.author }}</p>
                                                        <user-outlined  class="avatar-user" style="font-size: 20px"/>
                                                    </a-space>
                                                    <div style="clear:both;"></div>
                                                </div>
                                                <div>
                                                    <div class="message-box" style="float:right; background: rgb(148,236,105);">
                                                        {{item.text}}
                                                    </div>
                                                    <div style="clear:both;"></div>
                                                </div>

                                            </div>
                                            <div v-else-if="item.stage ==='detail'"  class="message-box" style="text-align: center">
                                                <span>{{item.content}}, 查看<a @click="()=>changeSteps(item.detailInfo)">详细日志</a></span>
                                            </div>
                                            <div v-else-if="item.stage ==='completed'" style="text-align: center">
                                                <robot-content :data="item"/>
                                            </div>
                                            <div v-else class="message-box gray" >
                                                <div v-if="!!item.content || !!item.summary_info" style="max-height: 400px;overflow-y: auto">
                                                    <span v-if="item.task_id">Task id: <a :href="'/'+h2+'?task_id=' + item.task_id" target="_blank">{{item.task_id}}</a></span>
                                                    <robot-content :data="item"/>
                                                    <loading-dots v-if="item.loading"/>
                                                </div>
                                                <div v-else>
                                                    {{item.text || item.content}}kjdkfs
                                                </div>
                                            </div>

                                        </div>
                                    </template>
                                </a-list-item-meta>
                            </a-list-item>
                        </template>
                    </a-list>
                    <a-list
                            v-if="loading"
                            :dataSource="[{text: 'Loading', author: 'Robot'}]"
                            :split="false"
                    >
                        <template #renderItem="{item}">
                            <a-list-item :class="`message-item ${item.role}`">
                                <a-list-item-meta >

                                    <template #title>
                                        <a-space>
                                            <a-avatar :src="require('@/assets/Machine Learning.svg')"/>
                                            <p :class="`author-${item.role}`">{{ item.author }}</p>
                                        </a-space>
                                    </template>
                                    <template #description>
                                        <div style="margin-left: 40px;color:#000000">
                                            <div class="message-box gray" >
                                                <a-space>
                                                    {{item.text}} <loading-dots/>
                                                </a-space>
                                            </div>

                                        </div>
                                    </template>
                                </a-list-item-meta>
                            </a-list-item>
                        </template>
                    </a-list>
                    <!--                                <div id="bottomElement" style="height: 1px"></div>-->
                    <a-back-top :target="getContainer" :visibilityHeight="500"/>
                </div>
            </a-col>
            <a-col span="3">
                <a-steps direction="vertical" :current="currentStep">
                    <template v-for="(step, index) in steps" :key="index">
                        <a-step :title="step.title" @click="()=>gotodetail(index)">
                            <template #title>
                                kkk
                                <a :href="'#' + index" v-if="index <= currentStep">{{step.title}}</a>
                                <span v-else>{{step.title}}</span>
                            </template>
                        </a-step>
                    </template>
                </a-steps>
            </a-col>
        </a-row>

    </div>
    <a-modal v-model:open="modal.open1" @ok="handleOk1" width="900px">
        <template #title>
            <b><android-outlined/> {{selectM.message}}</b>
        </template>
        <div style="max-height: 480px;overflow-y: auto">
            <robot-detail :data="selectM"/>
        </div>
    </a-modal>
    <span style="display: none">
       <download-outlined/>
    </span>

</template>

<script>
    import { reactive, ref, watch} from 'vue';
    import {  BackTop} from 'ant-design-vue';
    import moment from "moment";
    import {
        DownloadOutlined, UserOutlined
    } from '@ant-design/icons-vue';
    import {compare} from "../utils/request";

    import RobotContent from "../components/RobotContent";
    import RobotDetail from "../components/RobotDetail";
    import LoadingComponent from "../components/LoadingComponent";
    import {
        get_batch_task
    } from "../utils/biomed.api";
    import {fileRoot, get_args} from "../utils/request";
    let isDEV = false;
    const activeKey = ref(['1']);
    console.log('isDEV', isDEV);
    watch(activeKey, val => {
        console.log(val);
    });
    const selectedKeys = ['1'];
    const openKeys = ['sub1'];

    const scrollToBottom = () => {
        let msgEle = document.getElementById('messages');
        if(msgEle)msgEle.scrollTo({top: msgEle.scrollHeight, behavior: 'smooth'});
        // let bottomElement = document.getElementById("bottomElement");
        // if(bottomElement && bottomElement !== null) bottomElement.scrollIntoView({ behavior: 'smooth'});
    };
    // 0failed 1start 2improve_prompt 3tool_score 4workflow 5code 6summary 7completed
    const stages = [
        {stage: 2, cn: '需求分析', en: 'improve_prompt', title: 'Require analysis'},
        {stage: 3, cn: '工具选择', en: 'tool_score', title: 'Tool selection'},
        {stage: 4, cn: '流程组装', en: 'workflow', title: 'Workflow plan'},
        {stage: 5, cn: '代码编程', en: 'code', code: 'code_info', title: 'Code generation and Execution'},
        {stage: 5, cn: '所有代码', en: 'code', code: 'time', postfix: '已执行', title: ''},
        {stage: 6, cn: '代码编程', en: 'code', code: 'code_info', title: 'Summary'},
        {stage: 7, cn: '代码编程', en: 'completed', title: 'Task completed'},
    ];
    const steps = [
        {stage: 1, cn: '需求分析', en: 'improve_prompt', title: 'Start'},
        {stage: 2, cn: '需求分析', en: 'improve_prompt', title: 'Require analysis'},
        {stage: 3, cn: '工具选择', en: 'tool_score', title: 'Tool selection'},
        {stage: 4, cn: '流程组装', en: 'workflow', title: 'Workflow plan'},
        {stage: 5, cn: '代码编程', en: 'code', code: 'code_info', title: 'Code generation and Execution'},
        {stage: 6, cn: '代码编程', en: 'code', code: 'code_info', title: 'Summary'},
        {stage: 7, cn: '代码编程', en: 'completed', title: 'Task completed'},
    ];


    export default {
        props: ['egs', 'h2', 'icon', 'q'],
        components: {
            'a-back-top': BackTop,
            'robot-content': RobotContent,
            'robot-detail': RobotDetail,
            'loading-dots': LoadingComponent,
            DownloadOutlined,
            UserOutlined
            // 'pause-circle-outlined': PauseCircleOutlined
        },
        data() {
            let {h2} = this;
            const state = reactive({
                fileRoot,
                selectedKeys: selectedKeys,
                openKeys,
                modal: {
                    open: false
                },
                form: {
                    inputValue: ''
                },
                task_files: [],
                selectM: {},
                messages: [
                    // 初始化消息列表
                    {
                        time: 0,
                        author: h2,
                        text: '',
                        role: 'robot', // 消息类型：in表示接收，out表示发送，
                    },
                    // ...更多消息
                ],
                loading: true,
            });
            return {
                ...state,
                steps,
                currentStep: 0,
                task_files_obj: [],
                retrievers: [],
            }
        },
        created() {
            let {task_id, q} = get_args();
            console.log('task_id', task_id);
            if(q) {
                this.messages[0].role = 'user';
                this.messages[0].text = q;
            }
            if(task_id) this.getTaskInfo(task_id);
        },

        methods: {
            handleOk1(){
                this.modal.open1 = false;
            },
            getTaskInfo(task_id, beforeFunc){
                let obj = this;
                if(task_id) get_batch_task(task_id, (data)=>{
                    console.log('get_batch_task', data);
                    obj.loading = false;
                    // 0failed 1start 2improve_prompt 3tool_score 4workflow 5code 6summary 7completed
                    if(Array.isArray(data)){
                        this.formatPayload(data, task_id, beforeFunc);
                    }
                    else {
                        obj.messages.push({
                            author: obj.h2,
                            avatar: 'https://yyy.png', // 用户头像
                            text: 'Error: get_batch_task',
                            role: 'robot',
                            time: new Date() / 1000
                        });
                        scrollToBottom();
                    }
                })
            },
            formatPayload(result, task_id, beforeFunc, chat){
                let obj = this;
                let {messages, h2} = obj;
                let {task_stage,  payload, chat_no, add_time, update_time} = {};
                if(typeof beforeFunc === 'function') beforeFunc(chat_no);
                payload = payload || {};
                // let lastI = messages.length - 1;
                let { text} = payload;
                let now = new Date() / 1000;
                // let lastM = messages[lastI];
                let loading = task_stage > 0 && task_stage < 7;


                if(Array.isArray(result)){
                    let result1 = result.filter((r)=>task_stage ===1 || ['start'].indexOf(r.stage) === -1);
                    let rIndex = 0;
                    let timer = setInterval(()=>{
                        if(rIndex >= result1.length) {
                            clearInterval(timer);
                            // scrollToBottom();
                        }
                        else{
                            let r = result1[rIndex];
                            let {content, stage} = r;
                            let msgIndex = messages.findIndex(m=>{
                                let isMatch = m.stage === stage;
                                if(task_id) return m.task_id === task_id && isMatch;
                                if(chat) return m.chat_no === chat && isMatch;
                            });
                            if(msgIndex === -1 ){
                                if(task_stage === 1) {
                                    if(!content) {
                                        content = r.message;
                                        r.content = content;
                                        if(!r.time) r.time = now;
                                    }
                                }
                                let {cn, postfix, stage: stage1} = stages.find(s=>s.en === r.stage) || {};
                                if(!isNaN(stage1)) this.currentStep = stage1 - 1;
                                if(cn){
                                    let msgIndexDetail = messages.findIndex(m=>{
                                        let isMatch = m.stage === 'detail' && m.author === r.message;
                                        if(task_id) return m.task_id === task_id && isMatch;
                                        if(chat) return m.chat_no === chat && isMatch;
                                    });
                                    if(task_stage > stage1 && msgIndexDetail === -1) messages.push({
                                        detailInfo: result1[rIndex - 1] || {},
                                        time: r.time,
                                        stage: 'detail',
                                        content: cn + (postfix || '完成'),
                                        author: r.message,
                                        avatar: 'https://yyy.png', // 用户头像
                                        role: 'robot',
                                        task_id,
                                        task_stage,
                                        chat_no,
                                        loading: false
                                    })
                                }
                                let latestMsg = {
                                    ...r,
                                    author: r.message,
                                    avatar: 'https://yyy.png', // 用户头像
                                    role: 'robot',
                                    task_id,
                                    task_stage,
                                    chat_no,
                                    loading: false,
                                    ele_id: stage1 - 1
                                };
                                console.log(r.message, rIndex, task_stage, latestMsg.loading);
                                const updateM = (dict, wK, func)=>{
                                    let msgIndex1 = messages.findIndex(m=>{
                                        let isMatch = m.stage === stage && m[stage] === wK;
                                        if(task_id) return m.task_id === task_id && isMatch;
                                        if(chat) return m.chat_no === chat && isMatch;
                                    });
                                    let contentK = dict[wK];
                                    if(typeof func === 'function') contentK = func(contentK);
                                    let latest1 = {...latestMsg, [stage]: wK, content: contentK};
                                    if(msgIndex1 === -1 && (contentK != null || stage === 'completed')) {
                                        messages.push({...latest1, loading});
                                        // messages.sort(compare('time'));
                                        obj.messages = messages;
                                        scrollToBottom();
                                    }
                                    // else messages[msgIndex1] = latest1;

                                };
                                if(stage === 'workflow'){
                                    if(content && typeof content === 'object'){
                                        Object.keys(content).map(wK=>{
                                            updateM(content, wK, function (contentK) {
                                                return contentK;
                                            });
                                        })
                                    }
                                }
                                else if(stage === 'code'){
                                    if(content && typeof content === 'object'){
                                        let codeK = 'code_info';
                                        let {
                                            // total_result,
                                            partial_result
                                        } = content;
                                        partial_result = partial_result || [];
                                        if(partial_result){
                                            // let {code_info} = total_result || {};
                                            // code_info = code_info || [];
                                            partial_result.map((c, action)=>{
                                                let times = partial_result.filter(p=>p.action === action);
                                                let msgIndex1 = messages.findIndex(m=>{
                                                        let isMatch = m.task_id === task_id
                                                            && m.stage === stage
                                                            && m[stage] === codeK
                                                            && m.action === action;
                                                        if(task_id) return m.task_id === task_id && isMatch;
                                                        if(chat) return m.chat_no === chat && isMatch;
                                                    }
                                                );
                                                c.action = action;
                                                let latest1 = { ...latestMsg, [stage]: codeK, content: c, action};
                                                let latest2 = { ...latest1, content: times, code: 'time'};
                                                if(msgIndex1 === -1) {
                                                    messages.push(latest1);
                                                    messages.push(latest2);
                                                    // messages.sort(compare('time'));
                                                    obj.messages = messages;
                                                    scrollToBottom();
                                                }
                                                else {
                                                    // messages[msgIndex1] = latest1;
                                                    // messages[msgIndex1] = latest2;
                                                }


                                                // messages.sort(compare('time'));
                                                // obj.messages = messages;
                                            });
                                        }
                                    }

                                }
                                else if(stage === 'completed'){
                                    if(content && typeof content === 'object'){
                                        updateM(content, 'zip_path');
                                    }
                                }
                                else {

                                    if(msgIndex === -1) {
                                        messages.push({...latestMsg, loading});
                                        // else messages[msgIndex] = latestMsg;
                                        // messages.sort(compare('time'));
                                        console.log('msg', task_stage, r.message);
                                        obj.messages = messages;
                                        scrollToBottom();
                                    }
                                }

                            }
                            rIndex ++;
                        }
                    }, 2000);
                }
                if(text){
                    messages.push({
                        author: h2,
                        avatar: 'https://yyy.png', // 用户头像
                        role: 'robot',
                        text,
                        time: update_time || add_time
                    });
                    messages.sort(compare('time'));
                    obj.messages = messages;
                    scrollToBottom();
                }
            },
            changeSteps(current){
                this.selectM = current;
                this.modal.open1 = true;
                console.log('detailInfo', current)
            },
            formatTime(timeStamp){
                let now = new Date();
                timeStamp *= 1000;
                let diff = now - timeStamp;
                let ms = 24 * 60 * 60 * 1000;
                if(diff <= ms) return moment(timeStamp).format('HH:mm');
                return moment(timeStamp).format('YYYY-MM-DD HH:mm:ss');
            },
            gotodetail(index){
                console.log(index);
                window.location.hash = index;
            }
        }
    };
</script>

<style>

    .message-box{
        padding: 10px 10px;
        border-radius: 5px;
        text-align: justify;
        max-width: 100%;
        margin-right: 38px;
    }
    .message-time {
        background: rgb(218,218,218);padding: 2px 4px;border-radius: 4px;color: white;
        font-weight: normal;
    }

    .gray {
        background: #F2F2F2;
    }


    @keyframes write {
        0% {
            width: 0;
        }

        100% {
            width: 100%;
        }
    }

    @keyframes blink {
        50% {
            /* transparent是全透明黑色(black)的速记法，即一个类似rgba(0,0,0,0)这样的值。 */
            border-color: transparent; /* #00000000 */
        }
    }
    /* 隐藏滚动条 */
    ::-webkit-scrollbar {
        width: 0; /* 设置滚动条宽度 */
    }

    /* 滚动条轨道 */
    ::-webkit-scrollbar-track {
        background-color: #f1f1f1; /* 设置滚动条轨道背景颜色 */
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        background-color: #999; /* 设置滚动条滑块颜色 */
    }

    /* 滚动条滑块悬停状态 */
    ::-webkit-scrollbar-thumb:hover {
        background-color: #555; /* 设置滚动条滑块悬停状态颜色 */
    }
</style>